<ng-container [ngSwitch]="savedCalculationState$ | async">
  <div nxModalContent>
    <app-error *ngSwitchCase="apiStates.error" [appError]="savedCalculationError$ | async"></app-error>
    <app-loader *ngSwitchCase="apiStates.pending"></app-loader>
    <ng-container *ngSwitchDefault>
      <ng-container [ngSwitch]="attachmentsState$ | async">
        <ng-container *ngSwitchCase="apiStates.success">
          <div nxLayout="grid" class="before-check-documents">
            <div class="before-check-documents-wrapper">
              <p nxCopytext="normal" class="before-check-documents-description">
                <span class="color-danger">*</span>
                {{ 'modals.check-documents.title' + (remoteKindSuffix$ | async) | translate }}
              </p>
            </div>
            <div *ngIf="downloadAllPdf$ | async" class="before-check-documents-wrapper">
              <a [href]="downloadAllPdf$ | async" target="_blank" (click)="handleDownloadAll()" nxPlainButton
                type="button" class="nx-margin-right-m">
                <nx-icon name="pdf" class="nx-margin-right-2xs"></nx-icon>
                <span class="check-documents-btn">
                  {{ 'modals.check-documents.download-all-label' | translate }}
                </span>
              </a>
            </div>
          </div>
          <div class="check-documents-accordion">
            <nx-accordion [multi]="true" variant="light" *ngFor="let accordion of attachmentsGroupData$ | async">
              <nx-expansion-panel>
                <nx-expansion-panel-header>
                  <nx-expansion-panel-title>
                    {{ accordion.name | translate }}
                  </nx-expansion-panel-title>
                </nx-expansion-panel-header>
                <div nxLayout="grid" class="check-documents-grid">
                  <div nxRow>
                    <div nxCol="12,12,12,12,6">
                      <p nxCopytext="normal" class="check-documents-description">
                        {{ accordion.description | translate }}
                      </p>
                    </div>
                    <div nxCol="12,12,12,12,6">
                      <ul class="check-documents-list">
                        <li *ngFor="let attachment of accordion.attachments" class="check-documents-list-item">
                          <a [href]="attachment.downloadLink" nxPlainButton target="_blank"
                            (click)="handleDownload(attachment.downloadLink)" class="nx-margin-right-m">
                            <nx-icon name="pdf" class="nx-margin-right-2xs"></nx-icon>
                            <span class="check-documents-btn">
                              {{ attachment.name | translate }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </nx-expansion-panel>
            </nx-accordion>
          </div>
        </ng-container>
        <app-error *ngSwitchCase="apiStates.error" [appError]="attachmentsError$ | async"></app-error>
        <app-loader *ngSwitchDefault></app-loader>
      </ng-container>
    </ng-container>
  </div>
</ng-container>